import Rest from '@/services/Rest'

export default class ProfileService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/profiles'

}
